import './front.scss';
import Splide from '@splidejs/splide';
import Cookies from 'js-cookie';
import '@splidejs/splide/dist/css/splide.min.css';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

$(document).ready(function () {
    let content = $('.category-description');
    let contentManufacturer = $('#manufacturer');
    if ($(content).length || $(contentManufacturer).length) {
        let readContent = $('.read_content');
        $(document).on({
            click: function () {
                $(this).hide();
                $(readContent).find('.read_less').show();
                $('.truncate').hide()
                $('.notruncate').show();
            }
        }, '.read_content .read_more');
        $(document).on({
            click: function () {
                $(this).hide();
                $(readContent).find('.read_more').show();
                $('.truncate').show()
                $('.notruncate').hide();
            }
        }, '.read_content .read_less');
    }
    if (Cookies.get('bannertop')) {
        $('#bannertop_slide').remove();
        $('#header').addClass('nobannertop')
        $('#category_header_filter_top').addClass('nobannertopFilter')
    }
    if ($('#bannertop_slide').length > 0) {
        new Splide('#bannertop_slide', {
            direction: 'ttb',
            type: 'loop',
            height: '56px',
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true
        }).mount();
    }
});

$('.close_element').on('click', function () {
    $(this).parent().fadeOut(500);
    $('#header').addClass('nobannertop');
    Cookies.set('bannertop', true, {expires: 1, path: '/'});
});

$('#menu-icon').on('click', () => {
    $('body').addClass('modal-open');
    toggleMobileMenu();
});

function toggleMobileMenu() {
    $('#header').toggleClass('is-open');
    if ($('#_mobile_top_menu').is(':visible')) {
    } else {
        $('#_mobile_top_menu').css('display', 'block');
    }
}

$(document).ready(function () {
    $('.slick_images').not('.slick-initialized').slick(
        {
            dots: true,
            arrows: false
        }
    );
});

/****************************************************
 * Scroll du bloc de droite fiche produit (Mobile Only)
 */

var positionTopBtnAddtoCart = 0;
var productDetailsViewMobile = false;
var productDetailsPageReady = false;
var productDetailsReassuranceTop = 0;

var triggerTop = 0;
var triggerBottom = 0;
var initialTopLeftBloc = 0;

$(document).ready(function () {
    // Check if the screen width is mobile (e.g., max-width: 768px)
    if (window.innerWidth <= 768) {
        if ($('.left_bloc').css('display') == 'block') {
            productDetailsViewMobile = true;
        }

        if (productDetailsViewMobile) {
            positionTopBtnAddtoCart = parseInt($('.product-add-to-cart').position().top) - $('header').height() + parseInt($('.product-add-to-cart').outerHeight());
        }

        $('.right_bloc_content').css({
            maxWidth: $('.right_bloc').width()
        });

        if ($('.product-details-row').length) { // Page details produits
            $('.right_bloc').css({
                height: $('.right_bloc').height()
            });
            triggerTop = parseInt($('.right_bloc').position().top);
            triggerBottom = parseInt($('.left_bloc').position().top) + parseInt($('.left_bloc').height());
            initialTopLeftBloc = parseInt($('.left_bloc').position().top);
        }

        productDetailsPageReady = true;
    }
});

var lastScroll = 0;
var way = 1; // Scroll direction: 1 = down, 0 = up

/*
$(window).scroll(function () {
    if (window.innerWidth <= 768 && $('.product-details-row').length && productDetailsPageReady) { // Mobile only
        var currentScrollTop = $(window).scrollTop();

        // Determine scroll direction
        way = lastScroll > currentScrollTop ? 0 : 1;
        lastScroll = currentScrollTop;

        if (way) { // Scrolling down
            if (currentScrollTop >= triggerTop && currentScrollTop < triggerBottom) {
                $('.right_bloc_content').addClass('rbc-fixed').removeClass('rbc-stuck-down');
            }
            if (currentScrollTop + $('.right_bloc_content').outerHeight() >= triggerBottom) {
                $('.right_bloc_content').removeClass('rbc-fixed').addClass('rbc-stuck-down');
            }
        } else { // Scrolling up
            if (currentScrollTop <= triggerBottom - $('.right_bloc_content').outerHeight() && currentScrollTop > triggerTop) {
                $('.right_bloc_content').addClass('rbc-fixed').removeClass('rbc-stuck-down');
            }
            if (currentScrollTop <= triggerTop) {
                $('.right_bloc_content').removeClass('rbc-fixed').removeClass('rbc-stuck-down');
            }
        }

        // Handle "Add to Cart" button
        if (positionTopBtnAddtoCart !== 0) {
            if (currentScrollTop >= positionTopBtnAddtoCart) {
                $('.product-add-to-cart').addClass('stuck-down');
            } else {
                $('.product-add-to-cart').removeClass('stuck-down');
            }
        }
    }
});*/
